import { Component, HostListener, OnInit, computed, inject } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { filter } from 'rxjs';
import { BASEL_PAGE_CLASSES } from '../../core/constants/basel';
import { AuthService } from '../../core/services/auth.service';
import { MODULE_LIVE_CHAT, ModulesService } from '../../core/services/modules.service';
import { OverlayService } from '../../core/services/overlay.service';
import { BagDrawerComponent } from '../bag-drawer/bag-drawer.component';
import { FooterComponent } from '../footer/footer.component';
import { HeaderComponent } from '../header/header.component';
import { VisitorChatWidgetComponent } from '../../shared/components/visitor-chat-widget/visitor-chat-widget.component';

@Component({
  selector: 'app-public-layout',
  imports: [
    RouterOutlet,
    HeaderComponent,
    FooterComponent,
    BagDrawerComponent,
    VisitorChatWidgetComponent
  ],
  templateUrl: './public-layout.component.html'
})
export class PublicLayoutComponent implements OnInit {
  private readonly router = inject(Router);
  private readonly auth = inject(AuthService);
  private readonly modules = inject(ModulesService);
  readonly overlay = inject(OverlayService);
  showTop = false;

  readonly showVisitorChat = computed(
    () => this.modules.isEnabled(MODULE_LIVE_CHAT) && !this.auth.isLoggedIn()
  );

  ngOnInit(): void {
    this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe((event) => {
      this.applyPageClass((event as NavigationEnd).urlAfterRedirects);
    });
    this.applyPageClass(this.router.url);
  }

  closeSide(): void {
    this.overlay.closeAll();
  }

  @HostListener('window:scroll')
  onScroll(): void {
    this.showTop = window.scrollY > 400;
  }

  scrollTop(event: Event): void {
    event.preventDefault();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  private applyPageClass(url: string): void {
    const path = url.split('?')[0];
    document.body.classList.remove(...BASEL_PAGE_CLASSES);
    if (path === '/') {
      document.body.classList.add('home', 'page');
    } else if (path.startsWith('/product/')) {
      document.body.classList.add('single-product', 'woocommerce-page');
    } else if (path.startsWith('/shop')) {
      document.body.classList.add(
        'archive',
        'post-type-archive',
        'post-type-archive-product',
        'woocommerce-page'
      );
    } else {
      document.body.classList.add('page');
    }
  }
}
